import { render } from "./BaseCardBody.vue?vue&type=template&id=136a6790"
import script from "./BaseCardBody.vue?vue&type=script&lang=js"
export * from "./BaseCardBody.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__